import fallingStar from '@/assets/icons/clusters/falling_star.svg';
import fallingStarWhite from '@/assets/icons/clusters/falling_star_white.svg';
import flat from '@/assets/icons/clusters/flat.svg';
import flatWhite from '@/assets/icons/clusters/flat_white.svg';
import { forwardRef } from 'react';
import risingStar from '@/assets/icons/clusters/rising_star.svg';
import risingStarWhite from '@/assets/icons/clusters/rising_star_white.svg';
import seasonalDecliner from '@/assets/icons/clusters/seasonal_decliner.svg';
import seasonalDeclinerWhite from '@/assets/icons/clusters/seasonal_decliner_white.svg';
import seasonalFlat from '@/assets/icons/clusters/seasonal_flat.svg';
import seasonalFlatWhite from '@/assets/icons/clusters/seasonal_flat_white.svg';
import seasonalRiser from '@/assets/icons/clusters/seasonal_riser.svg';
import seasonalRiserWhite from '@/assets/icons/clusters/seasonal_riser_white.svg';
import styled from 'styled-components';
import sustainedDecliner from '@/assets/icons/clusters/sustained_decliner.svg';
import sustainedDeclinerWhite from '@/assets/icons/clusters/sustained_decliner_white.svg';
import sustainedRiser from '@/assets/icons/clusters/sustained_riser.svg';
import sustainedRiserWhite from '@/assets/icons/clusters/sustained_riser_white.svg';

const svgs = {
    'falling star': [fallingStar, fallingStarWhite],
    flat: [flat, flatWhite],
    'rising star': [risingStar, risingStarWhite],
    'seasonal flat': [seasonalFlat, seasonalFlatWhite],
    'seasonal decliner': [seasonalDecliner, seasonalDeclinerWhite],
    'seasonal riser': [seasonalRiser, seasonalRiserWhite],
    'sustained decliner': [sustainedDecliner, sustainedDeclinerWhite],
    'sustained riser': [sustainedRiser, sustainedRiserWhite],
    'tiktok falling star': [fallingStar, fallingStarWhite],
    'tiktok flat': [flat, flatWhite],
    'tiktok rising star': [risingStar, risingStarWhite],
    'tiktok seasonal flat': [seasonalFlat, seasonalFlatWhite],
    'tiktok seasonal decliner': [seasonalDecliner, seasonalDeclinerWhite],
    'tiktok seasonal riser': [seasonalRiser, seasonalRiserWhite],
    'tiktok sustained decliner': [sustainedDecliner, sustainedDeclinerWhite],
    'tiktok sustained riser': [sustainedRiser, sustainedRiserWhite],
    'instagram falling star': [fallingStar, fallingStarWhite],
    'instagram flat': [flat, flatWhite],
    'instagram rising star': [risingStar, risingStarWhite],
    'instagram seasonal flat': [seasonalFlat, seasonalFlatWhite],
    'instagram seasonal decliner': [seasonalDecliner, seasonalDeclinerWhite],
    'instagram seasonal riser': [seasonalRiser, seasonalRiserWhite],
    'instagram sustained decliner': [sustainedDecliner, sustainedDeclinerWhite],
    'instagram sustained riser': [sustainedRiser, sustainedRiserWhite],
};

const Wrapper = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
    color: ${({ theme, $light }) => ($light ? theme.gray_7 : theme.gray_3)};
`;

const ClusterIcon = forwardRef(({ cluster, light = false, ...props }, ref) => {
    if (cluster === 'tiktok no cluster')
        return (
            <Wrapper $light={light} {...props} ref={ref}>
                <span>&ndash;</span>
            </Wrapper>
        );

    if (cluster in svgs)
        return (
            <img
                src={svgs[cluster][+light]}
                alt={cluster}
                css="width: 1em; height: 1em;"
                {...props}
                ref={ref}
            />
        );

    return null;
});

export default ClusterIcon;
